import React, { Component } from 'react';
import {ContentDiv, BodyHeaderDiv, BodyHeaderText, SubmitBtn, MidCifBtn} from '../../theme/MorsTheme';
import {RESPONSE, API_BASE_URL, PDF_REPORTS_URL} from '../../resources/constant';

export default class morsAccessRequest extends Component {

  render() {
    var url = PDF_REPORTS_URL+'MORS_ENROLLMENT_FORM.pdf';

    return (
      <div>
        <BodyHeaderDiv>
            <BodyHeaderText>MORS Access Request</BodyHeaderText>
        </BodyHeaderDiv>
        <ContentDiv>
          <embed src={url} width="100%" height="500px" />
        </ContentDiv>
      </div>
    );
  }
}